module.exports = __webpack_public_path__ + "img/Red-R-2@2x.7e2f80ab.png";